import { Controller } from "stimulus"

export default class extends Controller {
  submit(e) {
    if (this.submitted) {
      e.preventDefault()
      return
    }

    this.submitted = true
    this.setDisabled(true)
  }

  // Re-enables after a Turbo submit that failed without navigating.
  reset(event) {
    if (event?.detail?.success) return

    this.submitted = false
    this.setDisabled(false)
  }

  setDisabled(disabled) {
    this.element.querySelectorAll('button[type="submit"]').forEach(btn => {
      btn.disabled = disabled
    })
  }
}
